<template>
  <detailTemplate :classCustom="'detail-docs'">
    <template #content>
      <div class="back-icon border-radius__50 clickable flex-row flex__center" @click="backListPage()">
        <i class="el-icon-back font-size__large"></i>
      </div>

      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <div class="font-size__large font-weight__bold margin-bottom-10" style="color: #007aff">
            CHI TIẾT LỊCH SỬ VĂN BẢN
          </div>
          <div>
            <el-table
              :data="tableData"
              border
              style="width: 100%">
              <el-table-column
                prop="date"
                label="THỜI GIAN"
                width="180">
              </el-table-column>
              <el-table-column
                prop="name"
                label="NƠI XỬ LÝ VĂN BẢN"
                width="180">
              </el-table-column>
              <el-table-column
                prop="address"
                label="GHI CHÚ">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </VuePerfectScrollbar>

    </template>
  </detailTemplate>
</template>

<script type="text/javascript">
    import VuePerfectScrollbar from "vue-perfect-scrollbar";
    import handleRequestErrorMixin from "../../handleRequestErrorMixin";
    import hanhchinhService from "../../../services/hanhchinhService";
    import {EventBus} from "../../../event-bus.js";

    export default {
        name: "LichTuan_Detail",
        mixins: [handleRequestErrorMixin],

        created() {
            // this.getListLeaders();
            // this.getData();
            // this.getAction();
        },

        data() {
            return {
                hcCaseMaster: {},
                hcCaseCalendar: {},
                hcCaseCalendarUsers: {},
                actions: [],
                approve: false,
                decline: false,
                update: false,
                cancel: false,
                selfCancel: false,
                listRooms: [],
                roomIdSelected: null,
                leaders: [],
                leadersSelected: [],
                tableData: [{
                    date: '17/12/2019 16:52',
                    name: 'Văn phòng',
                    address: 'Trình văn bản'
                }, {
                    date: '17/12/2019 16:52',
                    name: 'Văn thư',
                    address: 'Nhận văn bản'
                }, {
                    date: '17/12/2019 16:52',
                    name: 'Tô Mạnh Cường - Tổng Giám đốc',
                    address: 'Trình văn bản cho: Tô Mạnh Cường - Tổng Giám đốc'
                }, {
                    date: '17/12/2019 16:52',
                    name: 'Văn thư',
                    address: 'Trả văn bản:Văn phòng'
                }]
            }
        },

        components: {
            VuePerfectScrollbar,
            detailTemplate: () => import("../../common/detail.vue"),
            Multiselect: () => import("vue-multiselect")
        },

        computed: {
            caseMasterId() {
                return this.$route.params.id;
            }
        },

        watch: {
            caseMasterId() {
                this.getAction();
                this.getData();
            }
        },

        methods: {
            backListPage() {
                this.$router.push({
                    name: "vbLuongVanBan",
                    query: this.$route.query,
                    params: this.$route.params
                });
            },

            // lay danh sach lanh dao
            getListLeaders() {
                hanhchinhService.getListLDLichTuan().then(response => {
                    if (response.data.users) {
                        this.leaders = response.data.users;
                    }
                });
            },

            // lay danh sach phong hop free
            getListRoomFree() {
                hanhchinhService.getListRoomFree(this.hcCaseCalendar.startTime, this.hcCaseCalendar.endTime).then(
                    response => {
                        if (response.data.dataRoomFree) {
                            this.listRooms = response.data.dataRoomFree;
                        }
                    });
            },

            // lay du lieu lich tuan chi tiet
            getData() {
                hanhchinhService.getRegiscalendarweekDetail(this.caseMasterId).then(
                    respone => {
                        this.hcCaseMaster = respone.data.hcCaseMaster;
                        this.hcCaseCalendar = respone.data.hcCaseCalendar;
                        this.hcCaseCalendarUsers = respone.data.hcCaseCalendarUsers;

                        this.getListRoomFree();
                        this.roomIdSelected = null;
                        if (this.hcCaseCalendar.isNeedRoom === 1) {
                            this.hcCaseCalendar.isNeedRoom = true;
                            this.roomIdSelected = this.hcCaseCalendar.roomId;
                        }

                        if (this.hcCaseCalendarUsers !== null && this.hcCaseCalendarUsers.length > 0) {
                            let seft = this;
                            seft.leadersSelected = [];
                            this.hcCaseCalendarUsers.forEach(function (leader) {
                                seft.leadersSelected.push(leader);
                            });

                        }
                    });
            },

            // lay ra quyền thao tác
            getAction() {
                hanhchinhService.getAction(this.caseMasterId).then(respone => {
                    this.actions = respone.data.actions;
                    this.approve = false;
                    this.decline = false;
                    this.update = false;
                    this.cancel = false;
                    this.selfCancel = false;
                    respone.data.actions.forEach(item => {
                        // console.log(item.actionCode);
                        if (item.actionCode === "pheduyet") {
                            this.approve = true;
                        } else if (item.actionCode === "tuchoi") {
                            this.decline = true;
                        } else if (item.actionCode === "tuhuyyeucau") {
                            this.selfCancel = true;
                        } else if (item.actionCode === "huyyeucau") {
                            this.cancel = true;
                        } else if (item.actionCode === 'capnhat') {
                            this.update = true;
                        }
                    });
                });
            },

            // Phe duyet lich tuan
            approveRequest() {
                if (this.validateForm()) {
                    return;
                }

                let submitForm = {
                    action: 'pheduyet',
                    caseMasterId: this.hcCaseCalendar.caseMasterId,
                    note: this.hcCaseCalendar.note,
                    meetingTitle: this.hcCaseCalendar.meetingTitle,
                    meetingContent: this.hcCaseCalendar.meetingContent,
                    meetingPlace: this.hcCaseCalendar.meetingPlace,
                    startTime: this.hcCaseCalendar.startTime,
                    endTime: this.hcCaseCalendar.endTime,
                    otherInvolved: this.hcCaseCalendar.otherInvolved,
                    chairedUnit: this.hcCaseCalendar.chairedUnit,
                    videoConferenceUnit: this.hcCaseCalendar.videoConferenceUnit,
                    isNeedRoom: this.hcCaseCalendar.isNeedRoom ? 1 : 0,
                    roomId: this.roomIdSelected,
                    listUserIds: this.leadersSelected.map((listUser) => {
                        return listUser.userId;
                    }),
                };

                this.$confirm('Bạn chắc chắn muốn phê duyệt yêu cầu này ?',
                    {confirmButtonText: 'Xác nhận', cancelButtonText: "Hủy bỏ", type: "warning"})
                    .then(() => {
                        hanhchinhService.approveCalendarWeek(submitForm)
                            .then(() => {
                                this.notifySuccess('Đã phê duyệt yêu cầu thành công !');
                                EventBus.$emit("eventCalled", {});
                                this.backListPage();
                            })
                            .catch(error => this.getMessageError(error));
                    });

            },

            // Tu choi phe duyet lich tuan
            declineRequest() {
                if (!this.hcCaseCalendar.note) {
                    return this.notifyError('Vui lòng nhập lý do từ chối yêu cầu trong trường ghi chú');
                }
                if (this.hcCaseCalendar.note.length > 100) {
                    return this.notifyError('Lý do vượt quá 100 kí tự. Vui lòng kiểm tra lại.');
                }

                let submitForm = {
                    action: 'tuchoi',
                    caseMasterId: this.hcCaseCalendar.caseMasterId,
                    note: this.hcCaseCalendar.note,
                    meetingTitle: this.hcCaseCalendar.meetingTitle,
                    meetingContent: this.hcCaseCalendar.meetingContent,
                    meetingPlace: this.hcCaseCalendar.meetingPlace,
                    startTime: this.hcCaseCalendar.startTime,
                    endTime: this.hcCaseCalendar.endTime,
                    otherInvolved: this.hcCaseCalendar.otherInvolved,
                    chairedUnit: this.hcCaseCalendar.chairedUnit,
                    videoConferenceUnit: this.hcCaseCalendar.videoConferenceUnit,
                    isNeedRoom: this.hcCaseCalendar.isNeedRoom ? 1 : 0,
                    roomId: this.roomIdSelected,
                    listUserIds: this.leadersSelected.map((listUser) => {
                        return listUser.userId;
                    }),
                };

                this.$confirm('Bạn chắc chắn muốn từ chối yêu cầu này ?',
                    {confirmButtonText: 'Xác nhận', cancelButtonText: "Hủy bỏ", type: "warning"})
                    .then(() => {
                        hanhchinhService.approveCalendarWeek(submitForm)
                            .then(() => {
                                this.notifySuccess('Đã từ chối yêu cầu !');
                                EventBus.$emit("eventCalled", {});
                                this.backListPage();
                            })
                            .catch(error => this.getMessageError(error));
                    });

            },

            //validate
            validateForm() {
                if (!this.hcCaseCalendar.meetingTitle) {
                    this.notifyError('Vui lòng nhập tiêu đề');
                    this.$refs.title.focus();
                    return true;
                }

                if (this.hcCaseCalendar.meetingTitle.length > 255) {
                    this.notifyError('Tiêu đề vượt quá 255 kí tự. Vui lòng kiểm tra lại !');
                    this.$refs.title.focus();
                    return true;
                }

                // if (!this.hcCaseCalendar.meetingContent) {
                //     this.notifyError('Vui lòng nhập nội dung làm việc');
                //     this.$refs.meetingContent.focus();
                //     return true;
                // }

                if (this.hcCaseCalendar.meetingContent.length > 1000) {
                    this.notifyError('Nội dung công việc vượt quá 1000 kí tự. Vui lòng kiểm tra lại !');
                    return true;
                }

                if (!this.hcCaseCalendar.startTime) {
                    this.notifyError('Vui lòng chọn thời gian bắt đầu');
                    return true;
                }

                if (!this.hcCaseCalendar.endTime) {
                    this.notifyError('Vui lòng chọn thời gian kết thúc');
                    return true;
                }

                if (this.hcCaseCalendar.endTime < this.hcCaseCalendar.startTime) {
                    this.notifyError('Thời gian kết thúc trước thời gian bắt đầu');
                    return true;
                }

                if (!this.hcCaseCalendar.meetingPlace) {
                    this.notifyError('Vui lòng nhập địa điểm');
                    this.$refs.meetingPlace.focus();
                    return true;
                }

                if (this.hcCaseCalendar.meetingPlace.length > 200) {
                    this.notifyError('Địa điểm vượt quá 200 kí tự. Vui lòng kiểm tra lại !');
                    return true;
                }

                if (this.hcCaseCalendar.otherInvolved && this.hcCaseCalendar.otherInvolved.length > 500) {
                    this.notifyError('Thành phần tham dự vượt quá 500 kí tự. Vui lòng kiểm tra lại !');
                    return true;
                }

                if (this.hcCaseCalendar.chairedUnit && this.hcCaseCalendar.chairedUnit.length > 500) {
                    this.notifyError('Đơn vị chủ trì vượt quá 500 kí tự. Vui lòng kiểm tra lại !');
                    return true;
                }

                if (this.hcCaseCalendar.videoConferenceUnit && this.hcCaseCalendar.videoConferenceUnit.length > 500) {
                    this.notifyError('Đơn vị họp qua cầu truyền hình vượt quá 500 kí tự. Vui lòng kiểm tra lại !');
                    return true;
                }

                if (this.leadersSelected.length <= 0) {
                    this.notifyError('Vui lòng chọn danh sách lãnh đạo');
                    return true;
                }

                if (this.hcCaseCalendar.isNeedRoom && this.roomIdSelected === null) {
                    this.notifyError('Vui lòng chọn phòng họp');
                    return true;
                }

                return false;
            },

            // Cap nhap yc lich tuan
            updateRequest() {
                if (this.validateForm()) {
                    return;
                }

                this.roomIdSelected = this.hcCaseCalendar.isNeedRoom ? this.roomIdSelected : null;

                let submitForm = {
                    caseMasterId: this.hcCaseCalendar.caseMasterId,
                    note: this.hcCaseCalendar.note,
                    meetingTitle: this.hcCaseCalendar.meetingTitle,
                    meetingContent: this.hcCaseCalendar.meetingContent,
                    meetingPlace: this.hcCaseCalendar.meetingPlace,
                    startTime: this.hcCaseCalendar.startTime,
                    endTime: this.hcCaseCalendar.endTime,
                    otherInvolved: this.hcCaseCalendar.otherInvolved,
                    chairedUnit: this.hcCaseCalendar.chairedUnit,
                    videoConferenceUnit: this.hcCaseCalendar.videoConferenceUnit,
                    isNeedRoom: this.hcCaseCalendar.isNeedRoom ? 1 : 0,
                    roomId: this.roomIdSelected,
                    listUserIds: this.leadersSelected.map((listUser) => {
                        return listUser.userId;
                    }),
                };

                this.$confirm('Bạn chắc chắn muốn cập nhật yêu cầu này ?',
                    {confirmButtonText: 'Xác nhận', cancelButtonText: "Hủy bỏ", type: "warning"})
                    .then(() => {
                        hanhchinhService.updateCalendarWeek(submitForm)
                            .then(() => {
                                this.notifySuccess('Cập nhập yêu cầu thành công !');
                                EventBus.$emit("eventCalled", {});
                                this.backListPage();
                            })
                            .catch(error => this.getMessageError(error));
                    });
            },

            // Huy YCLT
            cancelRequest() {
                if (!this.hcCaseCalendar.note) {
                    return this.notifyError('Vui lòng nhập lý do hủy yêu cầu trong trường ghi chú');
                }

                if (this.hcCaseCalendar.note.length > 100) {
                    return this.notifyError('Lý do vượt quá 100 kí tự. Vui lòng kiểm tra lại.');
                }

                let submitForm = {
                    action: this.selfCancel === true ? 'tuhuyyeucau' : 'huyyeucau',
                    caseMasterId: this.hcCaseCalendar.caseMasterId,
                    note: this.hcCaseCalendar.note
                };

                let titleComfirm = this.selfCancel === true ?
                    'Bạn có chắc chắn muốn tự hủy yêu cầu này ?' :
                    'Bạn có chắc chắn muốn hủy yêu cầu này ?';

                this.$confirm(titleComfirm,
                    {confirmButtonText: 'Xác nhận', cancelButtonText: "Hủy bỏ", type: "warning"})
                    .then(() => {
                        hanhchinhService.cancelCalendarWeek(submitForm)
                            .then(() => {
                                this.notifySuccess('Hủy yêu cầu thành công !');
                                EventBus.$emit("eventCalled", {});
                                this.backListPage();
                            })
                            .catch(error => this.getMessageError(error));
                    });
            },

            notifyError(msg) {
                this.notify('Lỗi', msg, 'error', 2000);
            },
            notifySuccess(msg) {
                this.notify('Thông báo', msg, 'success', 2000);
            },
        }
    };
</script>




// WEBPACK FOOTER //
// src/views/adminstration/luongvanban/luongVb_DetailHistory.vue